import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M5 4.25A2.75 2.75 0 0 0 2.25 7v10A2.75 2.75 0 0 0 5 19.75h14A2.75 2.75 0 0 0 21.75 17V6.98A2.75 2.75 0 0 0 19 4.25H5zm15.2 2.38a1.25 1.25 0 0 0-1.2-.88H5a1.25 1.25 0 0 0-1.2.89L12 12.1l8.2-5.46zM3.75 8.4V17c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8.4l-7.83 5.22a.75.75 0 0 1-.84 0L3.75 8.4z",
		clipRule: "evenodd"
	})
});
export default SvgMail;
